module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/color/hockey-be8581324f7633b59cb2c9f0fbcb54fc.svg";